import React from 'react';
import AsyncChipSelect from './formsy/AsyncChipSelect';
import FormControl from '@mui/material/FormControl';
import { GetOrganisations } from 'services/openapiClient';
import { GetUsers } from 'services/user';

interface Option {
  id: string;
  label: string;
}

interface IProps {
  label: string;
  name: string;
  disabled?: boolean;
  description?: string;
  value?: string;
  resourceName: 'user' | 'organisation';
  onSelect: (option: Option) => void;
}

export default function ResourceAsyncSelector(props: IProps) {
  const {
    name,
    label,
    disabled,
    value,
    onSelect,
    resourceName,
  } = props;

  const [selectedOption, setSelectedOption] = React.useState<Option[]>([]);

  React.useEffect(() => {
    if (!value) {
      setSelectedOption([]);
    }
  }, [value]);

  function changeValue(option: Option) {
    setSelectedOption([option]);
    onSelect(option);
  }

  const handleSearchOptions = async (query: string): Promise<Option[]> => {
    if (resourceName === 'user') {
      const { items } = await GetUsers({
        pageIndex: 0,
        fullTextSearch: query,
      });
      if (!Array.isArray(items)) {
        return [];
      }
      return items.filter(item => item.aadUserId).map(item => {
        return {
          id: item.aadUserId,
          label: item?.email || '',
        };
      });
    } else if (resourceName === 'organisation') {
      const { items } = await GetOrganisations({
        pageIndex: 0,
        fullTextSearch: query,
      });
      if (!Array.isArray(items)) {
        return [];
      }
      return items.map(item => {
        return {
          id: item.id,
          label: item?.name || '',
        };
      });
    } else {
      console.error('resource name not supported');
      return [];
    }
  };


  const textFieldProps = {
    label,
    disabled,
    InputLabelProps: {
      shrink: true
    },
    variant: 'outlined'
  };

  return (
    <FormControl sx={{ minWidth: 200 }} className="z-10">
      <AsyncChipSelect
        disabled={disabled}
        value={selectedOption}
        name={name}
        placeholder={label}
        onChange={changeValue}
        onSearchOptions={handleSearchOptions}
        textFieldProps={textFieldProps}
      />
    </FormControl>
  );
}
